export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6249.5d73bcf9.jpg";